<template>
  <vue-editor
    ref="editor"
    v-model="editorContent"
    :editor-toolbar="customToolbar"
    :editor-options="editorOptions"
    @text-change="onTextChange"
  />
</template>

<script>
import {VueEditor, Quill} from 'vue2-editor'
import {isNull} from "lodash"

const Delta = Quill.import('delta')

/**
 * Rich text editor component based on vue2-editor and Quill
 */
export default {
    name: 'Vue2EditorComponent',
    components: {
        VueEditor
    },
    props: {
        /**
         * HTML content for the editor
         */
        content: {
            type: String,
            default: '',
            required: false
        }
    },
    data() {
        return {
            /**
             * Custom toolbar configuration for the editor
             */
            customToolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                [{'header': 1}, {'header': 2}],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'script': 'sub'}, {'script': 'super'}],
                [{'indent': '-1'}, {'indent': '+1'}],
                [{'size': []}],
                [{'header': []}],
                [{'color': []}, {'background': []}],
                [{'font': []}],
                [{'align': []}],
                ['clean']
            ],

            /**
             * Editor options including clipboard matchers
             */
            editorOptions: {
                modules: {
                    clipboard: {
                        matchers: [
                            ['*', this.plainTextMatcher],
                            ['B', this.boldMatcher],
                            [Node.TEXT_NODE, this.boldMarkdownMatcher]
                        ]
                    }
                }
            }
        }
    },

    computed: {
        editorContent: {
            get() {
                return isNull(this.content)
                    ? this.content
                    : this.content.replace(/\>\s+\</g, '')
            },
            set(value) {
                this.$emit('update:content', value)
            }
        }
    },
    mounted() {
        //console.log('editor mounted')
    },
    methods: {
        /**
         * Clean all pasted content down to plain text, removing extra blank lines
         */
        plainTextMatcher(node, delta) {
            let text = node.innerText || node.textContent
            text = text.replace(/\n\s*\n/g, "\n")

            // Return a new Delta with only the text content
            return new Delta().insert(text)
        },
        /**
         * Interpret <B> tags as bold text
         */
        boldMatcher(node, delta) {
            return delta.compose(new Delta().retain(delta.length(), {bold: true}))
        },
        onTextChange(delta, oldDelta, source) {
            /*console.log('delta', delta)
            console.log('oldDelta', oldDelta)
            console.log('source', source)*/
        },
        /**
         * Matcher to convert `**text**` (double-asterisk syntax) into bold
         */
        boldMarkdownMatcher(node, delta) {
            // Handle only text nodes
            if (node.nodeType === Node.TEXT_NODE) {
                const DELTA = new Delta();
                let text = node.data;
                let match;
                let lastIndex = 0;
                // Regex to match **text**
                const regex = /\*\*([^\*]+)\*\*/g;
                while ((match = regex.exec(text)) !== null) {
                    // Insert text before match as normal
                    if (match.index > lastIndex) {
                        DELTA.insert(text.slice(lastIndex, match.index));
                    }
                    // Insert matched text as bold
                    DELTA.insert(match[1], {bold: true});
                    lastIndex = regex.lastIndex;
                }
                // Insert any remaining text
                if (lastIndex < text.length) {
                    DELTA.insert(text.slice(lastIndex));
                }
                // If no matches, return original
                return match ? DELTA : delta;
            }
            return delta;
        }
    }
}
</script>

<style scoped>
/* Add your component-specific styles here */
</style>
